import { Button } from '@gazin/ecommerce-ui'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { makePageUrl } from 'src/util/url'

type PaginationItemProps = {
  page: number
  isCurrent?: boolean
}

export const PaginationItem = ({
  isCurrent = false,
  page,
}: PaginationItemProps) => {
  const route = useRouter()

  if (isCurrent) {
    return (
      <Button
        size="sm"
        fontSize="xs"
        width="4"
        colorScheme="primary"
        disabled
        _disabled={{ bgColor: '#0D71F0', cursor: 'default' }}
        value={page}
      >
        {page}
      </Button>
    )
  }
  return (
    <Link href={`${makePageUrl(page, route)}`}>
      <Button
        size="sm"
        fontSize="xs"
        width="4"
        bg="white"
        border="1px solid"
        borderColor="#DCDDE3"
        borderRadius=".1875rem"
        color="#646981"
        _hover={{ bg: '#0d6ff0aa', color: 'white' }}
        value={page}
      >
        {page}
      </Button>
    </Link>
  )
}
